// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDA69pFhhtib00x_FdWx-Y4_IVvrjYG_ag",
  authDomain: "illustra-6ca8a.firebaseapp.com",
  databaseURL: "https://illustra-6ca8a-default-rtdb.firebaseio.com",
  projectId: "illustra-6ca8a",
  storageBucket: "illustra-6ca8a.appspot.com",
  messagingSenderId: "643320223920",
  appId: "1:643320223920:web:d39c2493da8472ab934375",
  measurementId: "G-69S0CBVXMH"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar servicios
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1'); // Especificar región

// Configurar persistencia (mantener sesión iniciada)
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error("Error al configurar la persistencia:", error);
  });

export default app; 